import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class BackstageEvent extends DataModel {
  static readonly TYPE_ID: string = 'a97b47f220f1455b89a4545e467496fd';

  private constructor(
    public readonly name: string,
    public readonly code: string,
  ) {
    super();
  }

  get $typeId(): string {
    return BackstageEvent.TYPE_ID;
  }

  static create(args: {
    name: string,
    code: string,
  }): BackstageEvent {
    return new BackstageEvent(
        args.name,
        args.code,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): BackstageEvent {
    return new BackstageEvent(
        MapUtils.getString(map, 'name'),
        MapUtils.getString(map, 'code'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      name: this.name,
      code: this.code,
    };
  }

  clone(): this {
    return new BackstageEvent(
        this.name,
        this.code,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.name === this.name &&
      other.code === this.code;
  }
}

export class BackstageEventBuilder extends DataModelBuilder<BackstageEvent> {
  build(context: SerializationContext, map: SerializedData): BackstageEvent {
    return BackstageEvent.fromMap(context, map);
  }
}
